import React from 'react';

import { ReactComponent as user } from '../svg/user.svg';
import { ReactComponent as userWhite } from '../svg/userwhite.svg';
import { ReactComponent as facebook } from '../svg/facebook.svg';
import { ReactComponent as twitter } from '../svg/twitter.svg';
import { ReactComponent as instagram } from '../svg/instagram.svg';
import { ReactComponent as linkedIn } from '../svg/linkedin.svg';
import { ReactComponent as notifications } from '../svg/notifications.svg';
import { ReactComponent as expand } from '../svg/expand.svg';
import { ReactComponent as collapse } from '../svg/collapse.svg';
import { ReactComponent as sortAsc } from '../svg/sortasc.svg';
import { ReactComponent as sortDesc } from '../svg/sortdesc.svg';
import { ReactComponent as dropDown } from '../svg/dropdown.svg';
import { ReactComponent as search } from '../svg/search.svg';
import { ReactComponent as buttonCheck } from '../svg/buttoncheck.svg';
import { ReactComponent as isrcProtocol } from '../svg/isrcprotocol.svg';
import { ReactComponent as prev } from '../svg/prev.svg';
import { ReactComponent as next } from '../svg/next.svg';
import { ReactComponent as close } from '../svg/close.svg';
import { ReactComponent as deleteFile } from '../svg/deletefile.svg';
import { ReactComponent as downloadFile } from '../svg/downloadfile.svg';
import { ReactComponent as wDetail } from '../svg/wdetail.svg';
import { ReactComponent as rDetail } from '../svg/rdetail.svg';
import { ReactComponent as checkBoxChecked } from '../svg/checkboxchecked.svg';
import { ReactComponent as checkBoxUnchecked } from '../svg/checkboxunchecked.svg';
import { ReactComponent as checkBoxSemichecked } from '../svg/checkboxsemichecked.svg';
import { ReactComponent as clock } from '../svg/clock.svg';
import { ReactComponent as refresh } from '../svg/refresh.svg';
import { ReactComponent as flag_CZ } from '../svg/flag_CZ.svg';
import { ReactComponent as flag_EN } from '../svg/flag_EN.svg';

import { ReactComponent as phone } from '../svg/phone.svg';

import { registerCustomIconRenderer } from 'ps-gui';

const iconMap = {
	refresh,
	clock,
	user,
	userWhite,
	facebook,
	twitter,
	instagram,
	linkedIn,
	notifications,
	expand,
	collapse,
	sortAsc,
	sortDesc,
	dropDown,
	search,
	buttonCheck,
	isrcProtocol,
	prev,
	next,
	close,
	checkBoxChecked,
	checkBoxUnchecked,
	checkBoxSemichecked,
	phone,
	wDetail,
	rDetail,
	deleteFile,
	downloadFile,
	flag_CZ,
	flag_EN,
};

export function registerHarmoneyPortalIcons() {
	registerCustomIconRenderer(props => {
		const Icon = iconMap[props.name];
		if (!Icon) {
			return null;
		}
		return <Icon />;
	});
}

